/* eslint-disable import/no-anonymous-default-export */
import qs from 'querystring';

export default (api) => {

    const fetchNotifications = (payload) => {
        return api.get(`in-app-notifications?${qs.stringify(payload)}`);
    };

    const updateNotifications = () => {
        return api.put(`in-app-notifications`);
    };

    return {
        fetchNotifications,
        updateNotifications
    };
};
